// Ключи сообщений модалки завершения саммаризации, которые являются списком.
// Этот массив нужен, потому что у списков не нужно ставить точку в конце
export const CONTENT_LIST_KEYS = [
    'stop-dialog-content_admins_bsr_members_csr',
    'stop-dialog-content_admins_bsr_members_sr',
    'stop-dialog-content_admins_csr_members_bsr',
    'stop-dialog-content_admins_csr_members_sr',
    'stop-dialog-content_admins_sr_members_bsr',
    'stop-dialog-content_admins_sr_members_csr',
    'stop-dialog-content_members_bsr',
    'stop-dialog-content_members_csr',
    'stop-dialog-content_members_sr',
    'stop-dialog-content_owner_csr_admins_bsr',
    'stop-dialog-content_owner_csr_admins_bsr_members_csr',
    'stop-dialog-content_owner_csr_admins_bsr_members_sr',
    'stop-dialog-content_owner_csr_admins_csr_members_bsr',
    'stop-dialog-content_owner_csr_admins_csr_members_sr',
    'stop-dialog-content_owner_csr_admins_sr',
    'stop-dialog-content_owner_csr_admins_sr_members_bsr',
    'stop-dialog-content_owner_csr_admins_sr_members_csr',
    'stop-dialog-content_owner_csr_admins_sr_members_sr',
    'stop-dialog-content_owner_csr_members_bsr',
    'stop-dialog-content_owner_csr_members_sr',
    'stop-dialog-content_owner_sr_admins_bsr',
    'stop-dialog-content_owner_sr_admins_bsr_members_bsr',
    'stop-dialog-content_owner_sr_admins_bsr_members_csr',
    'stop-dialog-content_owner_sr_admins_bsr_members_sr',
    'stop-dialog-content_owner_sr_admins_csr',
    'stop-dialog-content_owner_sr_admins_csr_members_bsr',
    'stop-dialog-content_owner_sr_admins_csr_members_csr',
    'stop-dialog-content_owner_sr_admins_csr_members_sr',
    'stop-dialog-content_owner_sr_admins_sr_members_bsr',
    'stop-dialog-content_owner_sr_admins_sr_members_csr',
    'stop-dialog-content_owner_sr_members_bsr',
    'stop-dialog-content_owner_sr_members_csr',
];

// Ключи сообщений модалки завершения саммаризации, перед которыми нужно добавить заголовок
export const ADD_HEADER_CONTENT_KEYS = CONTENT_LIST_KEYS.filter(
    (key) =>
        ![
            'stop-dialog-content_members_bsr',
            'stop-dialog-content_members_csr',
            'stop-dialog-content_members_sr',
        ].includes(key)
);
